module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/62ba2cbe1bb712dbb8023b4f4297d7a6.gif";